/**
 * How long one two-step confirmation opens Integrations (3 Oct 2026, Tom: "take off the 30-minute re-ask").
 * Two-step is still required; a confirmation now lasts the whole sign-in (the 70-day session) instead of
 * 30 minutes. Mirrors the backend's `INTEGRATIONS_TWO_STEP` in `modules/command/permissions.ts` — change both.
 */
export const INTEGRATIONS_TWO_STEP_MINUTES = 70 * 24 * 60;
